"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDevServerSide = exports.isServerSide = void 0;
const isServerSide = () => {
    // In a Node.js environment (like SSR with Next.js)
    if (typeof window === 'undefined') {
        return true;
    }
    // In a React Native environment (no window or document)
    if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
        return false;
    }
    return false;
};
exports.isServerSide = isServerSide;
const isDevServerSide = () => process.env.NODE_ENV === 'development' && (0, exports.isServerSide)();
exports.isDevServerSide = isDevServerSide;
//# sourceMappingURL=index.js.map